// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607070114/js/" + chunkId + "." + {"44":"b768d6e7","225":"6a337b82","481":"33e82f0a","486":"6e293320","770":"e2c019d9"}[chunkId] + ".0.14630923819846775.chunk.js";
};